import React, { useContext, useState } from 'react'

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTv, faPrint, faPen } from '@fortawesome/free-solid-svg-icons'

import NavigationOptions from './PresentationData'
import PresentationContext from '../PresentationContext'

const PresentationNavigation = ({ url, graph, toggleFullScreen }) => {
    const [baseUrl, setBaseUrl] = useState('')
    const [editClientUrl, setEditClientUrl] = useState('')
    const [activeItem, setActiveItem] = useState({})
    const [next, setNext] = useState(null)
    const [previous, setPrevious] = useState(null)
    const [navigationOptions, setNavigationOptions] = useState(NavigationOptions)

    const { presentationHeaders } = useContext(PresentationContext)

    useEffect(() => {
        const {
            showIncome,
            showAssets,
            showCurrentCoverage,
            showIncomeLoss,
            showPlanComparison,
            showCoverageScenarios,
            showBenefitCostComparison,
        } = presentationHeaders

        let toSetNav = [...NavigationOptions]
        if (!showIncome || showIncome === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'income')
        }
        if (!showAssets || showAssets === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'assets')
        }
        if (!showCurrentCoverage || showCurrentCoverage === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'coverage')
        }
        if (!showIncomeLoss || showIncomeLoss === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'with-event-loss')
        }
        if (!showPlanComparison || showPlanComparison === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'plans')
        }
        if (!showCoverageScenarios || showCoverageScenarios === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'with-event')
        }
        if (!showBenefitCostComparison || showBenefitCostComparison === 'No') {
            toSetNav = toSetNav.filter((p) => p.link !== 'asset-value')
        }
        setNavigationOptions(toSetNav)
    }, [presentationHeaders])

    useEffect(() => {
        if (navigationOptions.length === 0) {
            setPrevious(null)
            setNext(null)
            return
        }

        const urlParts = url.split('/')
        setBaseUrl(urlParts.slice(0, 4).join('/'))
        let editUrlParts = urlParts.slice(0, 3)
        editUrlParts.push('client')
        setEditClientUrl(editUrlParts.join('/'))
        const activeIndex = navigationOptions.map((p) => p.link).indexOf(graph)
        setActiveItem(navigationOptions[activeIndex])

        if (activeIndex - 1 >= 0) {
            setPrevious(navigationOptions[activeIndex - 1])
        } else {
            setPrevious(null)
        }

        if (activeIndex + 1 < navigationOptions.length) {
            setNext(navigationOptions[activeIndex + 1])
        } else {
            setNext(null)
        }
    }, [url, graph, navigationOptions])

    const { clientName } = useContext(PresentationContext)

    return (
        <>
            <div className="col-section col-no-margin">
                <div id="graph-title" className="col-xs-6">
                    <h1>
                        {clientName}
                        <Link to={editClientUrl} className="noprint">
                            <FontAwesomeIcon
                                style={{ marginLeft: '15px' }}
                                icon={faPen}
                                title="Edit Client"
                            />
                        </Link>
                        <FontAwesomeIcon
                            icon={faTv}
                            style={{ marginLeft: '15px', cursor: 'pointer' }}
                            onClick={toggleFullScreen}
                            title="Full Screen Mode"
                            className="noprint"
                        />
                        <FontAwesomeIcon
                            icon={faPrint}
                            style={{ marginLeft: '15px', cursor: 'pointer' }}
                            onClick={() => window.print()}
                            title="Print Page"
                            className="noprint"
                        />
                    </h1>
                </div>
                <div id="graph-nav" className="col-xs-6">
                    {next && (
                        <Link to={`${baseUrl}/${next.link}`} className="btn arrow-btn btn-right">
                            NEXT
                        </Link>
                    )}

                    {previous && (
                        <Link
                            to={`${baseUrl}/${previous.link}`}
                            className="btn arrow-btn-left btn-right"
                        >
                            PREV
                        </Link>
                    )}
                </div>
            </div>
            <ul id="graph-nav-status">
                {navigationOptions.map((choice) => {
                    const isActive = choice.link === activeItem.link
                    const { display, link } = choice

                    return (
                        <li key={display} className={isActive ? 'active' : ''}>
                            <Link to={`${baseUrl}/${link}`}>
                                <span></span>
                                <p>{display}</p>
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </>
    )
}

export default React.memo(PresentationNavigation)
